import { useState } from "react";
import { useI18n } from "../../i18n/i18nService";


const SearchBar = ({ onSearch }) => {
    const { t } = useI18n();
    const [searchTerm, setSearchTerm] = useState("");
    const handleSearch = (e) => {
        e.preventDefault();
        if (searchTerm.trim()) {
            onSearch(searchTerm);
            setSearchTerm("");
        }
    };
    return (
        <form
            onSubmit={handleSearch}
            className="flex w-full max-w-2xl items-center space-x-2 border border-light-secondary/30 dark:border-white/10 bg-light-surface/20 dark:bg-ligth-surface/80 px-4 py-2 rounded-md"
        >
            <input
                type="text"
                placeholder={t("search")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full bg-transparent  text-white placeholder-white focus:outline-none"
            />
            <button
                type="submit"
                className="bg-light-secondary/20 dark:bg-dark-secondary/20 p-2 rounded-md hover:bg-light-secondary/30 dark:hover:bg-dark-secondary/30"
            >
                {/* Icône Loupe */}
                <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z" />
                </svg>
            </button>
        </form>
    )
}

export default SearchBar;